export default __webpack_public_path__ + "static/testimonial-david-rodriguez-014ede0c7eb78d99905b0489da50cfcb.png";